(function () {
    window.onload = function () {
        var frameName = new ds07o6pcmkorn({
            openElementId: "#shielded-logo",
            modalID: "modal",
        });
        frameName.init();
    }
})();